// Modify default `options`
document.addEventListener('algolia.hooks.initialize', function() {

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    return html`
    <div class="aa-PanelLayout aa-Panel--scrollable">
      <div class="aa-PanelSections">
        <div class="aa-PanelSection--left">
          ${displaySuggestions &&
    html`
              <div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle"
                  >${algoliaShopify.translations.suggestions}</span
                >
                <div class="aa-SourceHeaderLine" />
              </div>
              ${elements.querySuggestionsPlugin}
            `}
          ${elements.collections} ${elements.articles} ${elements.pages}
          ${elements.redirectUrlPlugin}
        </div>
        <div class="aa-PanelSection--right">
          ${elements.products}
        </div>
      </div>
    </div>
  `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainProductsTemplate', function (defaultTemplate, templateOptions, elements) {
    const { html } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSection">
          ${elements.products}
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html, state } = templateOptions;
    return html`
        <div class="aa-SourceHeader">
        <span class="aa-SourceHeaderTitle">
          ${algoliaShopify.translation_helpers.render_title(
                  resource,
                  state.query
          )}
        </span>
            <div class="aa-SourceHeaderLine" />
        </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-footer">
        <a
          class="aa-SeeAllBtn"
          href="${window.Shopify.routes.root}search?q=${state.query}"
        >
          ${algoliaShopify.translations.allProducts}
          (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
        </a>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      return html`
          <a
                  href="${itemLink}"
                  class="aa-ItemLink aa-ProductItem"
          >
              <div class="aa-ItemContent">
                  <div class="aa-ItemPicture twcss-flex aa-ItemPicture--loaded twcss-text-center">
                      <img
                              src="${algoliaShopify.helpers.compactImage(item)}"
                              alt="${item.title}"
                      />
                  </div>
                  <div class="aa-ItemContentBody">
                      <div class="aa-ItemContentTitleWrapper">
                          <div class="aa-ItemContentTitle twcss-text-center">
                              ${components.Highlight({hit: item, attribute: "title"})}
                              <span class="algolia-variant">
                                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                              </span>
                          </div>
                      </div>
                      <div class="twcss-text-center !twcss-block twcss-h-8">
                          ${item.variants_count <= 1 && html`<span class="sku twcss-text-sm">${item.sku}</span>`}
                      </div>
                      <div class="aa-ItemContentPrice twcss-flex-wrap twcss-justify-center">
                          ${!!window.customerId && item.variants_max_price > item.variants_min_price && html`<span
                                  class="twcss-text-sm">Alk.</span>`}
                          ${!!window.customerId && html`<span
                                  class="twcss-text-sm price-item price-item--regular"
                                  >${item.variants_min_price} €</span>`}
                          ${!!window.customerId && html`<span
                                  class="pst-discount twcss-w-24 twcss-font-bold twcss-text-sm twcss-block twcss-text-orange-500 twcss-animate-pulse twcss-w-24 twcss-h-8 twcss-bg-slate-200 twcss-rounded"
                                  data-sku="${item.sku}"></span>`}
                          ${!!window.customerId && html`<span
                                  class="pst-price twcss-font-bold twcss-w-full twcss-text-center twcss-text-sm twcss-block twcss-animate-pulse twcss-h-8 twcss-bg-slate-200 twcss-rounded"
                                  data-sku="${item.sku}"></span>`}
                      </div>
                  </div>
              </div>
          </a>
      `;
    });

  algoliaShopify.hooks.registerHook('beforeAutocompleteArticlesTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { html, item, components } = templateOptions;
    return html`
      <a href="${itemLink}" class="aa-ItemLink">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle !twcss-text-sm">
                ${components.Highlight({ hit: item, attribute: 'title' })}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompletePagesTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { html, item, components } = templateOptions;
    return html`
      <a href="${itemLink}" class="aa-ItemLink aa-ProductItem">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle !twcss-text-sm">
                ${components.Highlight({ hit: item, attribute: 'title' })}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteSuggestionsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <a
        class="aa-ItemLink aa-ItemWrapper"
        href="${window.Shopify.routes.root}search?q=${item.query}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitle !twcss-text-sm">
              ${components.Highlight({ hit: item, attribute: 'query' })}
            </div>
          </div>
        </div>
        <div class="aa-ItemActions">
          <button
            class="aa-ItemActionButton"
            title={"Fill query with ${item.query}"}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z" />
            </svg>
          </button>
        </div>
      </a>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteCollectionsTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { html, item, components } = templateOptions;
    return  html`
      <a href="${itemLink}" class="aa-ItemLink">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle !twcss-text-sm">
                ${components.Highlight({ hit: item, attribute: 'title' })}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });
  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    // Modify default options, then return them
    const { html, state } = templateOptions;
    const { query } = state;
    return html`
      <div class="aa-SourceHeader">
        <span class="aa-SourceHeaderTitle">
          ${`Results for "${query}"`}
        </span>
        <div class="aa-SourceHeaderLine" />
      </div>
    `;
  });

});